import React from 'react';

import { WebinarPlayerContext } from '$/components/WebinarPlayer/context';

import ScaleSlider from '../ScaleSlider';
import { TimelineTrack } from './TimelineTrack';
import { ZoomScaleProvider } from './ZoomScaleProvider';

const Timeline: React.FC<{ startZoomed?: boolean; hideZoom?: boolean }> = ({
  startZoomed,
  hideZoom,
}) => {
  const { domain, vimeoDuration, onZoomScaleChange, ewebinar } =
    React.useContext(WebinarPlayerContext);
  if (!domain) return null;

  return (
    <ZoomScaleProvider
      domain={domain}
      startZoomed={startZoomed}
      duration={vimeoDuration}
      exitDurationSecs={ewebinar.exitRoomDurationSecs}
      onZoomScaleChange={onZoomScaleChange}
    >
      <div className='flex flex-col bg-gray-0 rounded-b-xl'>
        <TimelineTrack />
        <ScaleSlider hideZoom={hideZoom} />
      </div>
    </ZoomScaleProvider>
  );
};

export default Timeline;
